import { render, staticRenderFns } from "./DeviceStatusIcon.vue?vue&type=template&id=49bfcbc0&scoped=true&"
import script from "./DeviceStatusIcon.vue?vue&type=script&lang=js&"
export * from "./DeviceStatusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bfcbc0",
  null
  
)

export default component.exports